var _path, _path2;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgLeftArrow(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 56,
    height: 32,
    viewBox: "0 0 56 32",
    fill: "current",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.7504 21.9999C16.816 22.0007 16.881 21.9877 16.9413 21.9619C17.0016 21.9361 17.0558 21.8979 17.1004 21.8499C17.1483 21.805 17.1864 21.7508 17.2124 21.6906C17.2385 21.6304 17.252 21.5655 17.252 21.4999C17.252 21.4343 17.2385 21.3694 17.2124 21.3092C17.1864 21.249 17.1483 21.1947 17.1004 21.1499L11.9604 15.9999L17.1004 10.8499C17.1933 10.757 17.2454 10.6311 17.2454 10.4999C17.2454 10.3686 17.1933 10.2427 17.1004 10.1499C17.0076 10.057 16.8817 10.0049 16.7504 10.0049C16.6192 10.0049 16.4933 10.057 16.4004 10.1499L10.9004 15.6499C10.8526 15.6947 10.8145 15.749 10.7884 15.8092C10.7624 15.8694 10.7489 15.9343 10.7489 15.9999C10.7489 16.0655 10.7624 16.1304 10.7884 16.1906C10.8145 16.2508 10.8526 16.305 10.9004 16.3499L16.4004 21.8499C16.4451 21.8979 16.4993 21.9361 16.5596 21.9619C16.6198 21.9877 16.6849 22.0007 16.7504 21.9999Z",
    fill: "current"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M38 8L30 13.89V24H36V18H40V24H46V14L38 8Z",
    fill: "current"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLeftArrow);
export default __webpack_public_path__ + "static/media/leftArrow.fbc3e1b1aab8b8673404e19c27062062.svg";
export { ForwardRef as ReactComponent };